export const CODEC_PLAIN = 0;
export const CODEC_XOR = 1;
